import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Missions from '../views/Missions.vue'
import MissionsDetails from '../views/MissionsDetails.vue'
import Contact from '../views/Contact.vue'
import ContactMessage from '../views/ContactMessage.vue'
import Sermons from '../views/Sermons.vue'
import Thankyou from '../views/Thankyou.vue'
import Homeschool from '../views/Homeschool.vue'
import BQ from '../views/BQ.vue'
import Church from '../views/Church.vue'
import Radio from '../views/Radio.vue'
import Pastors from '../views/Pastors.vue'
import Donations from '../views/Donations.vue'

import Settings from '../views/admin/Settings.vue'
import Foundation from '../views/Foundation.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/missions', name: 'Missions', component: Missions },
  { path: '/missions/:id', name: 'MissionsDetails', component: MissionsDetails, props: true },
  { path: '/bq', name: 'BQ', component: BQ },
  { path: '/contact', name: 'Contact', component: Contact },
  { path: '/contact/sent', name: 'ContactMessage', component: ContactMessage },
  { path: '/sermons', name: 'Sermons', component: Sermons },
  { path: '/foundation', name: 'Foundation', component: Foundation },
  { path: '/homeschool', name: 'Homeschool', component: Homeschool },
  { path: '/thankyou', name: 'Thankyou', component: Thankyou },
  { path: '/church', name: 'Church', component: Church },
  { path: '/radio', name: 'Radio', component: Radio },
  { path: '/pastors', name: 'Pastors', component: Pastors },
  { path: '/donations', name: 'Donations', component: Donations },

  { path: '/admin', name: 'Settings', component: Settings },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }

})

router.beforeEach((to, from, next) => {

  const lastComponent = localStorage.getItem("component") || "Home"

  if (to.matched.some(route => route.name == "Thankyou")) {
    next()
    // localStorage.setItem("component", to.name)
  } else {
    localStorage.setItem("lastComponent", from.name)
    next()
  }
})

export default router
